/**
 * /studies/new — a new study in the signed-in user's workspace (the shared page lives in
 * `features/studies/NewStudyPage.tsx`; the Admin entry is `/admin/studies/new`).
 */

import { createFileRoute } from "@tanstack/react-router";
// zod/mini: the same parser, tree-shaken to what these search params use. Full zod would ride in
// the app's entry chunk, since validateSearch is not split out with the page.
import { z } from "zod/mini";
import { NewStudyPage } from "@/features/studies/NewStudyPage";
import { SCOPE_TABS } from "@/features/studies/scopeTabs";
import { ensureStudiesEnabled } from "@/features/studies/stage";

function WorkspaceNewStudy() {
  const { brief, autorun, step } = Route.useSearch();
  return <NewStudyPage brief={brief} autorun={autorun} step={step} />;
}

export const Route = createFileRoute("/_auth/_agents/studies/new")({
  // `brief` pre-seeds the first chat message (the onboarding kickoff passes the research brief);
  // `autorun` sends it immediately instead of pre-filling the composer. `step` is the scope step
  // on screen — carried here too so the panel can follow the agent's first write, which is the
  // write most worth watching.
  // Validated against the real step list, exactly as `/studies/$id` does — the two carry the same
  // param between them, so accepting a wider set here just keeps junk in the URL until the
  // redirect drops it.
  validateSearch: z.object({
    brief: z.optional(z.string()),
    autorun: z.optional(z.boolean()),
    step: z.optional(z.enum(SCOPE_TABS)),
  }),
  beforeLoad: ({ context, preload }) => ensureStudiesEnabled(context.queryClient, preload),
  component: WorkspaceNewStudy,
});
